import React from 'react'
import styled from 'styled-components'
import { statusConverter } from '../../artcoded/statusAzmanot'

type Props = {
  statusCode: number
}

const StatusCircle = ({ statusCode }: Props) => {
  const { status, color } = statusConverter(statusCode)

  return (
    <Circle
      $color={color ?? '#ced3ff'}
      title={status ?? ''}
      aria-label={status ?? ''}
    >
      {status?.at(0) ?? '?'}
    </Circle>
  )
}

const Circle = styled.div<{ $color: string }>`
  flex-shrink: 0;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  font-size: 0.8em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #297F76;
  user-select: none;
`

export default StatusCircle
